// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
  production: false,
  mainUrl: 'https://sales.acsicorp.com/sep-api/api/',
  //apiUrl: 'https://localhost:44361/api/',
  gpmapiUrl: "https://localhost:44333/",
  ESDapiUrl: 'http://10.118.60.186:50503/api/',
  esdMyLearningUrl: 'http://10.118.60.186:4455',
  ssoUrl: "https://login.microsoftonline.com/common/oauth2/authorize?response_type=id_token&client_id=20f294f1-1b06-49ad-babe-3f501b05ce06&redirect_uri=https://gsd.innovasolutions.com/&nonce=4a3ada0e-ceaf-40f2-953f-26a6b8fde2c4",
  apiUrl: 'https://gsd-api.innovasolutions.com/api/',
  GSDapiUrl: 'https://qa-gsd-api.innovasolutions.com:8081/api/',
  // Api Url for Oraggkps1 server
  //apiUrl: 'https://qa-gsd-api.innovasolutions.com:5000/api/',
  //GSDapiUrl:'https://qa-gsd-api.innovasolutions.com:8081/api/',
  // apiUrl: 'http://10.118.60.173:8899/api/',


  // apiUrl: 'http://10.118.60.173:8899/api/',
  esdMyLearningurl: 'http://10.118.60.186:4455/programs',



  // apiUrl: 'http://10.118.60.173:8899/api/',
  elasticSearchURL: "http://localhost:9200/",
  // elasticSearchURL: 'http://localhost:9200/',

  // adalConfig: {
  //   tenant: '6690176b-5932-48e9-a8f5-01a63568339c',
  //   clientId: 'e0c19d2e-124d-4529-a8dd-3412b4560761',
  //   redirectUri: 'http://localhost:4200/',
  //   // cacheLocation: 'localStorage',
  //   // popUp: true
  //   // popUp: true,
  //   postLogoutRedirectUri: 'http://localhost:4200/searchpage'
  //   // }
  // },

  analystsAdalConfig: {
    // tenant: '7896c5aa-71b4-47c3-98d4-e707bdd7462f',
    clientId: '20f294f1-1b06-49ad-babe-3f501b05ce06',
    // from new ui changes : clientId: "c721a99c-1003-4757-86ee-b2873c75ecde",
    // redirectUri: 'https://qa.sales.ggktech.com/',
    redirectUri: 'http://localhost:4200/',
    scope: ''
    // cacheLocation: 'localStorage',
    // popUp: true
    // popUp: true,
    // postLogoutRedirectUri: 'http://localhost:4200/searchpage',
    // endpoints: {
    //   'https://localhost:44391/': 'f97fb914-4993-4534-b1e3-e8cb931a483c'
    // }
  },

  // analystsAdalConfig: {
  //   // tenant: '8b1459d9-a97b-40c0-8b80-4b93692f0837',
  //   clientId: '57d3a182-8168-439c-92d2-f7767db26af8',
  //   // instance: 'https://login.microsoftonline.com/common/',
  //   // redirectUri: 'https://qa.sales.ggktech.com/',
  //   redirectUri: 'http://localhost:4200/'
  //   // cacheLocation: 'localStorage',
  //   // popUp: true
  //   // popUp: true,
  //   // postLogoutRedirectUri: 'http://localhost:4200/searchpage',
  //   // endpoints: {
  //   //   'https://localhost:44391/': 'f97fb914-4993-4534-b1e3-e8cb931a483c'
  //   // }
  // },

  syAppsAdalConfig: {
    tenant: "6d042944-4be7-44f5-8392-9b295e9c7c50",
    clientId: "4f18b721-4b2f-42bb-99d5-bdd5edeec2c3",
    redirectUri: "http://localhost:4200/",
    // cacheLocation: 'localStorage',
    // popUp: true
    // popUp: true,
    postLogoutRedirectUri: "http://localhost:4200/home",
    // endpoints: {
    //   'https://localhost:44391/': 'f97fb914-4993-4534-b1e3-e8cb931a483c'
    // }
  },

  innovaAdalConfig: {
    tenant: "8ab5b329-be41-45c5-91e9-f257046abb3d",
    clientId: "2f3d82c0-26f1-452a-aeb6-81ee06cfedde",
    redirectUri: "https://qa.sales.ggktech.com/",

    // redirectUri: 'http://localhost:4200/',
    // cacheLocation: 'localStorage',
    // popUp: true
    // popUp: true,
    // postLogoutRedirectUri: 'http://localhost:4200/searchpage',
    // endpoints: {
    //   'https://localhost:44391/': 'f97fb914-4993-4534-b1e3-e8cb931a483c'
    // }
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
